import script from "./FeedbackModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackModal.vue?vue&type=style&index=0&id=6fb2adbd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb2adbd"]])

export default __exports__